import dayjs from 'dayjs';

import { useAbility } from '@cast/shared-ability-data-access';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import {
  useCluster,
  isAnywhereCluster,
} from '@cast/shared-cluster-context-data-access';

const WOOP_AVAILABLE_FROM = '2025-04-06';

// TODO (aivaras): remove this hook and only depend on FF once WIRE implements
// https://castai.atlassian.net/browse/WIRE-1149

export const useCanViewWoop = () => {
  const { currentOrganization } = useOrganizations();
  const { cluster } = useCluster();

  const isAnywhere = isAnywhereCluster(cluster);

  const isNewOrganization = dayjs(currentOrganization?.createdAt).isAfter(
    WOOP_AVAILABLE_FROM
  );

  const canView = useAbility().can('view', 'ClusterWorkloadAutoscaler');

  return canView || isAnywhere || isNewOrganization;
};
